export const handlePartnerSearch = () => {
  const partnerSearchField = document.querySelector('#partner-search');

  if (!partnerSearchField) return

  partnerSearchField.addEventListener('keyup', function () {
    const searchValue = this.value.toLowerCase();
    const items = document.querySelectorAll('.single-partner');

    items.forEach(function (item) {
      item.classList.remove('hidden');

      const partnerFilterDropdowns = document.querySelectorAll('.partner-filters .dropdown');
      partnerFilterDropdowns.forEach(dropdown => {
        const menuButton = dropdown.querySelector('.menu-button span');
        menuButton.textContent = 'Show all';
        dropdown.querySelectorAll('a').forEach(link => link.classList.remove('bg-gray-100'));
      })

      const description = item.getAttribute('data-description').toLowerCase();
      if (description.includes(searchValue)) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  });
}